import { UnidAnchoBanda, TipoPlan, Udm, Moneda } from "../../../isp.žapi.planes/constantesApiPlanes";

//borrar tiposPlan
const tiposPlan = [
    { label: "Plan de Internet", value: TipoPlan.PlanInternet },
    { label: "Servicios Gener.", value: TipoPlan.ServiciosGen },
    { label: "Articulo", value: TipoPlan.Articulo },
];

const udsAnchoBanda = [
    { label: "Mbps", value: UnidAnchoBanda.Megas },
    { label: "Gbps", value: UnidAnchoBanda.Gigas },
];

const udms = [
    { label: "Mensual", value: Udm.Mensual },
];

const monedas = [
    { label: "Soles (S/)", value: Moneda.Soles },
    { label: "Dólares ($)", value: Moneda.Dolares },
];

export { udsAnchoBanda, tiposPlan, udms, monedas };
